module.exports = __webpack_public_path__ + "img/Combined-Shape.7a772960.svg";